/**
 * Typing - cinematic subtitle reveal with golden glow bursts.
 * Characters appear in bursts with glow, golden underline grows beneath.
 */

export function initTyping(root: HTMLElement): () => void {

  const elements = root.querySelectorAll<HTMLElement>('[data-typing]');
  const cleanups: (() => void)[] = [];

  for (const el of elements) {
    const fullText = el.textContent ?? '';
    const speed = Number(el.dataset.typingSpeed ?? 30);
    const delay = Number(el.dataset.typingDelay ?? 0);
    const burstSize = 3;

    el.textContent = '';
    el.style.visibility = 'visible';
    el.classList.add('typing-container');

    const textWrap = document.createElement('span');
    textWrap.className = 'typing-text';
    el.appendChild(textWrap);

    const underline = document.createElement('span');
    underline.className = 'typing-underline';
    el.appendChild(underline);

    const timeouts: ReturnType<typeof setTimeout>[] = [];
    let charIndex = 0;

    const startTimeout = setTimeout(() => {
      function typeBurst() {
        if (charIndex >= fullText.length) {
          el.classList.add('typing-complete');
          return;
        }

        const end = Math.min(charIndex + burstSize, fullText.length);
        const chunk = fullText.slice(charIndex, end);

        for (let i = 0; i < chunk.length; i++) {
          const span = document.createElement('span');
          span.className = 'typing-char';
          span.textContent = chunk[i] ?? '';
          span.style.animationDelay = `${i * 20}ms`;
          textWrap.appendChild(span);
        }

        const progress = end / fullText.length;
        underline.style.transform = `scaleX(${progress})`;

        charIndex = end;
        const t = setTimeout(typeBurst, speed * burstSize);
        timeouts.push(t);
      }

      typeBurst();
    }, delay);
    timeouts.push(startTimeout);

    cleanups.push(() => {
      for (const t of timeouts) clearTimeout(t);
      el.textContent = fullText;
      el.classList.remove('typing-container', 'typing-complete');
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
